module.exports = __webpack_public_path__ + "static/media/play-3.bd905c58.svg";